
import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";

var nJwt = require('njwt');

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    redirect: '/dashboard/ecommerce'
                },
                {
                    path: '/usuario-confirmacion-registro/:id',
                    name: 'dashboard-analytics',
                    component: () => import('./componentsMap/mail/MainMessage.vue'),
                    meta: {
                        rule: 'editor',
                    }
                },
                {
                    path: '/dashboard/ecommerce',
                    name: 'dashboard-ecommerce',
                    component: () => import('./componentsMap/dashboard/DashboardECommerce.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'eCommerce', url:'/apps/eCommerce/shop'},
                            { title: 'Checkout', active: true },
                        ],
                        pageTitle: 'Checkout',
                        rule: 'editor'
                    }
                },
                {
                    path: '/usuario-confirmacion-recuperacion-email/:hash',
                    name: 'usuario-confirmacion-recuperacion-email',
                    component: () => import('./componentsMap/mail/MainMessageRecover.vue'),
                    meta: {
                        rule: 'editor',
                    }
                },
                {
                    path: '/list/school-supplies',
                    name: 'list.school.supplies',
                    component: () => import('./componentsMap/students/ListSchoolSupplies.vue'),
                    meta: {
                        rule: 'editor',
                    }
                },
        // =============================================================================
        // Rutas Principales
        // =============================================================================
                {
                    path: '/location/mapgrafi',
                    name: 'ubicacion-mapgrafi',
                    component: () => import('./componentsMap/location/Location.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                         // =============================================================================
                         // ACCOUNTS INICIO
                //          // =============================================================================
                {
                    path: '/account/login',
                    name: 'accountLogin',
                    component: () => import('./componentsMap/account/Account.vue'),
                    meta: {
                        rule: 'editor',
                    }
                },
                {
                    path: '/account/close',
                    name: 'accountClose',
                    component: () => import('./componentsMap/dashboard/DashboardECommerce.vue'),
                    meta: {
                        rule: 'admin',
                    }
                },
                {
                    path: '/account/register',
                    name: 'accountRegister',
                    component: () => import('./componentsMap/account/AccountRegister.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/account/forgot',
                    name: 'accountForgot',
                    component: () => import('./componentsMap/account/AccountForgot.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                         // =============================================================================
                         // ACCOUNTS FIN 
                         // =============================================================================
                {
                    path: '/students/list',
                    name: 'misEstudiantes',
                    component: () => import('./componentsMap/students/Students.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/my-addresses',
                    name: 'misDirecciones',
                    component: () => import('./componentsMap/location/Location.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/list/checkout-products',
                    name: 'productosCheckout',
                    component: () => import('./componentsMap/eCommerce/ECommerceCheckout.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/list/shop-products/:cod_clasificacion/:param_busqueda',
                    name: 'productosShop',
                    component: () => import('./componentsMap/eCommerce/ECommerceShop.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/list/products',
                    name: 'productosList',
                    component: () => import('./componentsMap/eCommerce/ECommerceWishList.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/data-billing',
                    name: 'datosFacturacion',
                    component: () => import('./componentsMap/dataBilling/DataBilling.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/list/complete',
                    name: 'listComplete',
                    component: () => import('./componentsMap/listComplete/ListComplete.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/list/order-buy',
                    name: 'ordenesCompra',
                    component: () => import('./componentsMap/orderBuy/OrderBuy.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
            ],
            beforeEnter:(to,from,next)=>{
                if(!_.isEmpty(localStorage.getItem("accessToken"))){
                    var token   = localStorage.getItem("accessToken");
                        nJwt.verify(token,'UsCzNQqTQIVXSBlRzbWoPGFnipURU4Fm',function(err,verifiedJwt){
                            if(err){ // si a sido modificado o eliminado
                                localStorage.removeItem("accessToken");
                                localStorage.removeItem('userInfo');
                                localStorage.removeItem('student');
                                localStorage.removeItem('carItems');
                                localStorage.removeItem('list_direcciones');
                                localStorage.removeItem('iva');
                                localStorage.removeItem('porcion');
                                localStorage.removeItem('discount_post');
                                localStorage.removeItem('date_pre_sale');
                                location.reload();
                                next();
                            }else{
                                var fecha_inicio        =   moment(verifiedJwt.body.iat,'X').format('YYYY/DD/MM');
                                var fecha_expiracion    =   moment(verifiedJwt.body.exp,'X').format('YYYY/DD/MM');
                                  // aqui puedo validar lo de preventa
                                var statusToken  = moment(moment().format('YYYY/DD/MM')).isBetween(fecha_inicio,fecha_expiracion , null, '[]'); 
                                // _this.statusPreventa  = true;
                                    if(statusToken){
                                        next();
                                    }else{
                                        next();
                                    }
                            }
                        });
                }
                else
                {
                    next();
                }
            }
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
                {
                    path: '/callback',
                    name: 'auth-callback',
                    component: () => import('@/views/Callback.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                // // {
                // //     path: '/pages/login',
                // //     name: 'page-login',
                // //     component: () => import('@/views/pages/login/Login.vue'),
                // //     meta: {
                // //         rule: 'editor'
                // //     }
                // // },
                // {
                //     path: '/pages/register',
                //     name: 'page-register',
                //     component: () => import('@/views/pages/register/Register.vue'),
                //     meta: {
                //         rule: 'editor'
                //     }
                // },
                // {
                //     path: '/pages/forgot-password',
                //     name: 'page-forgot-password',
                //     component: () => import('@/views/pages/ForgotPassword.vue'),
                //     meta: {
                //         rule: 'editor'
                //     }
                // },
                // {
                //     path: '/pages/reset-password',
                //     name: 'page-reset-password',
                //     component: () => import('@/views/pages/ResetPassword.vue'),
                //     meta: {
                //         rule: 'editor'
                //     }
                // },
                // {
                //     path: '/pages/lock-screen',
                //     name: 'page-lock-screen',
                //     component: () => import('@/views/pages/LockScreen.vue'),
                //     meta: {
                //         rule: 'editor'
                //     }
                // },
                // {
                //     path: '/pages/comingsoon',
                //     name: 'page-coming-soon',
                //     component: () => import('@/views/pages/ComingSoon.vue'),
                //     meta: {
                //         rule: 'editor'
                //     }
                // },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/maintenance',
                    name: 'page-maintenance',
                    component: () => import('@/views/pages/Maintenance.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

export default router
